import React from "react";
import {Menu} from "antd";
import {Link} from "react-router-dom";

const DEFAULT_STYLE = {color: "#ffffff", fontWeight: '500', fontSize: '1.1em'}
const NavMenu = ({mode, defaultSection}) => {
    return (
        <Menu style={{backgroundColor: "#58B2DC"}} mode={mode} selectedKeys={[defaultSection]} items={[
            {
                key: '/',
                label: (<Link to="/" target="_blank" rel="noopener noreferrer"> Home </Link>),
                style: DEFAULT_STYLE
            },
            {
                key: '/download',
                label: (<Link to="/download" target="_blank" rel="noopener noreferrer"> Download </Link>),
                style: DEFAULT_STYLE
            },
            {
                key: '/bugreports',
                label: (<Link to="/bugreports" target="_blank" rel="noopener noreferrer"> Bug Reports</Link>),
                style: DEFAULT_STYLE
            },
            {
                key: '/tutorial',
                label: (<Link to="/tutorial" target="_blank" rel="noopener noreferrer"> Tutorial </Link>),
                style: DEFAULT_STYLE
            },
            {
                key: '/extras',
                label: (<Link to="/extras" target="_blank" rel="noopener noreferrer"> Extra-Material </Link>),
                style: DEFAULT_STYLE
            },
            {key: 'references', label: (<Link to="/references" target="_blank" rel="noopener noreferrer">
                    References
                </Link>),
                style:DEFAULT_STYLE
            }
        ]}/>
    );
};

export default NavMenu;